import { Injectable, NgZone } from '@angular/core';
import {
    Auth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signInWithPopup,
    sendEmailVerification,
    sendPasswordResetEmail,
} from "@angular/fire/auth";
import { Firestore } from '@angular/fire/firestore';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})


export class AuthService {

  constructor(
    public afs: Firestore,
    public afAuth: Auth,
    public router: Router,
    public ngZone: NgZone) { }

  // Sign in with email/password
  SignIn(email: string, password: string) {
    return signInWithEmailAndPassword(this.afAuth, email, password);
  }

  // Sign up with email/password
  SignUp(email, password) {
    console.log('SignUp');
    console.log(password);
    return createUserWithEmailAndPassword(this.afAuth, email, password)
        .then((result) => {
            /* Call the SendVerificaitonMail() function when new user sign
          up and returns promise */
            this.SendVerificationMail();
            // this.SetUserData(result.user);
        })
        .catch((error) => {
            window.alert(error.message);
        });
  }

  // Send email verfificaiton when new user sign up
  async SendVerificationMail() {
    console.log('SendVerificationMail');
    const user = await this.afAuth.currentUser;
    return sendEmailVerification(user).then(() => {
      window.alert('Se ha enviado un correo para la confirmación de cuenta.');
    });
  }

  // Reset Forggot password
  async ForgotPassword(passwordResetEmail:string){
    // try {
      return sendPasswordResetEmail(this.afAuth, passwordResetEmail)
          .then((ok) => {
              console.log("reset password succes =>", ok);
          })
          .catch((err) => {
              console.log("reset password error =>", err.message);
          });
    // } catch (error) {
    //   console.log(error);
    // }
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(sessionStorage.getItem('user'));
    return user !== null && user.emailVerified !== false ? true : false;
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return signInWithPopup(this.afAuth, provider)
      .then((result) => {
        this.ngZone.run(() => {
          this.router.navigate(['delegate']);
        });
        // this.SetUserData(result.user);
      })
      .catch((error) => {
        window.alert(error);
      });
  }

  /* Setting up user data when sign in with username/password,
    sign up with username/password and sign in with social auth
    provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  // SetUserData(user) {
  //   const userRef: AngularFirestoreDocument<any> = this.afs.doc(
  //     `users/${user.uid}`
  //   );
  //   const userData: User = {
  //     uid: user.uid,
  //     email: user.email,
  //     displayName: user.displayName,
  //     photoURL: user.photoURL,
  //     emailVerified: user.emailVerified,
  //   };
  //   return userRef.set(userData, {
  //     merge: true,
  //   });
  // }

  // Sign out
  SignOut() {
    return this.afAuth.signOut().then(() => {
      sessionStorage.removeItem('isAuthenticated');
      this.router.navigate(['login']);
    });
  }

  showMessage(text: string, icon: any) {
    Swal.fire({
      text: text,
      icon: icon,
    }).then((result) => {});
  }
}
